import React, { forwardRef } from 'react';
import ErrorMessage from '../common/ErrorMessage';
import Label from './Label';

interface PrimaryInputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  type?: string;
  placeholder?: string;
  label?: string;
  labelClassname?: string;
  id?: string;
  name?: string;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  errors?: string;
  disabled?: boolean;
  varient?: 'primary' | 'primary_rounded';
  className?: string;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  inputRef?: React.Ref<HTMLInputElement>;
  parentClass?: string;
  required?: boolean;
  startIcon?: React.ReactNode;
  passwordShow?: React.ReactNode;
  layerStyle?: string;
  maxLength?: number;
}

const PrimaryInput = forwardRef<HTMLInputElement, PrimaryInputProps>(
  (
    {
      maxLength = 150,
      layerStyle,
      type = 'text',
      placeholder = '',
      label = '',
      labelClassname = '',
      id = '',
      name = '',
      // value,
      onChange = () => {},
      errors = '',
      disabled = false,
      varient = 'primary',
      className = '',
      onKeyDown = () => {},
      parentClass,
      required = false,
      startIcon,
      passwordShow,
      ...rest
    },
    ref,
  ) => {
    // const varientType = {
    //   primary: 'w-full p-2 border rounded-[6px] text-sm',
    //   primary_rounded:
    //     'w-full py-[8px] 2xl:py-[15px] px-[20px] lg:px-[28px] 2xl:px-[36px] text-xs xl:text-base border border-primary-500 rounded-[6px]',
    // };

    return (
      <div className={parentClass}>
        {label && (
          <Label id={id} labelClassname={` ${labelClassname} ${varient}`}>
            {label}
            {required && <span className="text-danger">*</span>}
          </Label>
        )}
        <div
          className={
            layerStyle ? layerStyle : 'position-relative icon-input mb-2'
          }
        >
          <input
            {...rest}
            ref={ref}
            type={type}
            id={id}
            name={name}
            // {...(value !== undefined ? { value } : {})}
            // { value &&   value={value ?? ''}}
            onChange={(e) => {
              let value = e.target.value;
              if (type === 'number' && maxLength && value.length > maxLength) {
                value = value.slice(0, maxLength);
                e.target.value = value;
              }
              onChange?.(e);
            }}
            className={`form-control rounded ${className}`}
            placeholder={placeholder}
            disabled={disabled}
            onKeyDown={onKeyDown}
          />
          {startIcon}
          {passwordShow}
        </div>
        <ErrorMessage message={errors} />
      </div>
    );
  },
);

export default PrimaryInput;
